App.OrderMapPopupV1Component = Em.Component.extend
  classNames: [ 'order-map-popup', 'v1' ]

  session: Em.inject.service()
  env:     Em.inject.service('environment')

  courierBinding: Ember.Binding.oneWay('order.courier')
  couriers: null

  statusName : (->
    @get('env').translate( "order.status.#{ @get('order.status') }" )
  ).property('order.status')

  courierPickupTime: (->
    date = moment(new Date(@get('order.pick_up_at')))
    if date.isSame(moment(), 'day')
      date.format('H:mm')
    else
      date.format('DD MMMM в H:mm')
  ).property('order.pick_up_at')

  isDeliveryFree: (->
    not @get('order.delivery_price') or @get('order.delivery_price') == 0
  ).property('order.delivery_price')

  nextStepName: (->
    order = @get('order')
    return unless order

    status = order.get('status')

    stepName = {
      # todo i18n (скорее всего неактуальный файл)
      pending:   'Подтвердить заказ'
      confirm:   'Перевести в статус «Готовится»'
      preparing: 'Перевести в статус «Приготовлен»'
      prepared:  'Перевести в статус «Курьер забрал заказ»'
      delivery:  'Перевести в статус «Доставлен»'
    }[status]

    if order.get('takeaway') and status is 'prepared'
      return 'Перевести в статус «Клиент забрал заказ»'

    stepName
  ).property('order.status', 'order.takeaway')

  ###
  # Флаги для отображения
  ###
  isInTerminalState: (->
    @get('order.status') in ['complete', 'undo']
  ).property('order.status')

  isCanceled: Em.computed.equal('order.status', 'undo')
  isComlete: Em.computed.equal('order.status', 'complete')

  canAssignCourier: (->
    return false if @get('order.takeaway')
    @get('order.status') in [ 'confirm', 'preparing', 'prepared', 'delivery' ]
  ).property(
    'order.status',
    'order.takeaway')

  hintMessage: (->
    message = ''

    # todo i18n
    if @get('order.isPaymentCard')
      message += "Подтвердите заказ, чтобы клиент смог его оплатить "

    message += {
      pending: """
        После подтверждения клиенту будет отправленно
        SMS-сообщение, а менеджеры ресторана получат уведомление о новом заказе
        """
      confirm:   'Заказ подтвержден'
      preparing: 'Заказ собирается'
      prepared:  'Заказ собран'
      delivery:  'Заказ доставляется курьером'
      complete:  'Заказ был успешно доставлен'
      undo:      'Заказ был отменен'
    }[@get('order.status')]

    if @get('shouldAssignCourier')
      message += ' Назначьте курьера, чтобы перевести заказ в следующий статус.'

    message
  ).property(
    'order.isPaymentCard',
    'order.status',
    'shouldAssignCourier')

  # Очень странно
  hasCourier: Em.computed.bool('order.courier.id')

  shouldAssignCourier: (->
    order = @get('order')

    if order.get('takeaway')
      return false

    if (order.get('status') is 'prepared') and not @get('hasCourier')
      return true
    false
  ).property('order.status', 'hasCourier', 'order.takeaway')

  actions:
    assignCourier: (courier) ->
      order = @get('order')
      order.set('courier', courier)
      order.save()

      false

    setNextStatus: ->
      # todo i18n
      return false unless confirm('Сменить статус?')

      order = @get('order')
      currentStatus = order.get('status')

      switch currentStatus
        when 'pending'
          order.set('status', 'confirm').save()
        when 'confirm'
          order.set('status', 'preparing').save()
        when 'preparing'
          order.set('status', 'prepared').save()
        when 'prepared'
          if not order.get('takeaway')
            order.set('status', 'delivery').save()
          else
            order.set('status', 'complete').save()
        when 'delivery'
          order.set('status', 'complete').save()

